module.exports = __webpack_public_path__ + "static/media/add-app-block.a636a53d.png";